<template>
  <div>
    <!-- <h1>{{year}}년 {{month}}월 {{day}}일</h1> -->
    <h2>{{start}} - {{end}}</h2>
  </div>
</template>

<script>

export default {
  name: 'DayTitle',
  components: {

  },
  props: [
    'itemId'
  ],
  data() {
    return {
      year:undefined,
      month:undefined,
      day:undefined,
      start:undefined,
      end:undefined
    };
  },
  methods: {

  },
  computed: {

  },
  created() {
    let itemId = this.itemId.split('-');
    this.year = itemId[0];
    this.month = itemId[1];
    this.day = itemId[2];
    this.start = itemId[3];
    this.end = itemId[4];
  },
  watch: {

  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DayTitle.vue